module.exports = __webpack_public_path__ + "img/index_pic4.40a7a3c0.png";